import { render, staticRenderFns } from "./IconDownRight.vue?vue&type=template&id=0504c47b&"
import script from "./IconDownRight.vue?vue&type=script&lang=js&"
export * from "./IconDownRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports